// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"button--wrapper--DijTDmW9","isBlock":"button--isBlock--3M8bJ5T6","button":"button--button--3svPcQBU","is-primary":"button--is-primary--3HMsow4H","isPrimary":"button--is-primary--3HMsow4H","is-danger":"button--is-danger--1rYicqmN","isDanger":"button--is-danger--1rYicqmN","is-raised":"button--is-raised--x8j8w11n","isRaised":"button--is-raised--x8j8w11n","is-flat":"button--is-flat--1M7OLeos","isFlat":"button--is-flat--1M7OLeos","is-disabled":"button--is-disabled--1rAMgkGk","isDisabled":"button--is-disabled--1rAMgkGk"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/Button/button.scss
// module id = 496
// module chunks = 0